import React, {useState} from "react";
import Search from "../Search/Search";
import SendForSignature from "../SendForSignature/SendForSignature";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";

const  Database = () => {

    const [activeCargoCaseTable, setActiveCargoCaseTable] = useState(false);
    const [activeSelectDoc, setActiveSelectDoc] = useState(false);
    const [activeDocSetEditBnt, setActiveDocSetEditBnt] = useState(false);
    const [activeTableRowMenu, setActiveTableRowMenu] = useState(null);

    return (

        <div className="man__container">
            <div className="cargo-case-search-create-button">
                <Search/>
                <div className={activeDocSetEditBnt ? "cargo-case-search-create-button__buttons" : "cargo-case-search-create-button__buttons hide"}>
                    {/*<SendForSignature/>*/}
                </div>
            </div>
            <div className="cargo-case-main-block">
                {activeCargoCaseTable ? (
                    <div>

                    </div>
                ) : (
                    <>
                        <CreateNewDocuments
                            hiddenButtons={true}
                        />
                    </>
                )}
            </div>
        </div>
    )
}
export default Database;